import React, { createContext, useContext, useState, useMemo } from 'react';

export interface EditableTableContextValue {
  editingRowId: string | number | null;
  setEditingRowId: (id: string | number | null) => void;
  isAddingNewRow: boolean;
  setIsAddingNewRow: (value: boolean) => void;
}

const EditableTableContext = createContext<EditableTableContextValue | null>(null);

export function EditableTableProvider({ children }: { children: React.ReactNode }): React.ReactElement {
  const [editingRowId, setEditingRowId] = useState<string | number | null>(null);
  const [isAddingNewRow, setIsAddingNewRow] = useState(false);

  const value = useMemo<EditableTableContextValue>(
    () => ({
      editingRowId,
      setEditingRowId,
      isAddingNewRow,
      setIsAddingNewRow,
    }),
    [editingRowId, isAddingNewRow]
  );

  return (
    <EditableTableContext.Provider value={value}>
      {children}
    </EditableTableContext.Provider>
  );
}

export function useEditableTableContext(): EditableTableContextValue {
  const ctx = useContext(EditableTableContext);
  if (ctx == null) {
    throw new Error('useEditableTableContext must be used within EditableTableProvider');
  }
  return ctx;
}
